import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { cn } from "../lib/utils";

export const IconButton = forwardRef<HTMLButtonElement, Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> & {
  label: string;
  children: ReactNode;
}>(({ label, className, type, ...props }, ref) => (
  <button
    aria-label={label}
    className={cn("sqk-icon-button", className)}
    ref={ref}
    type={type ?? "button"}
    {...props}
  />
));
IconButton.displayName = "IconButton";
